import { Entities } from "src/app/data/vo/PricingSummaryVO";

export interface TermsAndConditionsRow {
    terms_version_id: number,
    name: string,
    description: string,
    version_number: number,
    download_url: string,
    is_accepted: boolean,
    accepted_on: Date
}

export class TermsAndConditionsData {
    data: TermsAndConditionsRow[];
    count: number;
    constructor() { }
}

export interface PaymentGatewayData {
    currency_id: number;
    discount_code_id?: string;
    entities: Array<Entities>;
}

export interface CustomerBusinessProfile {
    business_profile: {
        business_profile_id: number;
        business_id: number;
        business_name: string;
        credit_account_number: number;
        is_credit_account_number_approved: boolean;
    };
    id: number;
    name: string;
}

export interface BusinessProfile {
    address: string;
    business_id: string;
    business_name: string;
    credit_account_number: string;
    is_credit_account_number_approved: boolean;
}

export interface ConnectionData {
    connection_id: number,
    buyer_id: number,
    buyer_name: string,
    seller_id: number,
    seller_name: string,
    currency: string,
    status: string
}
